module.exports = __webpack_public_path__ + "img/txt.a1b2fb4c.png";